import { customToast } from 'src/utils/custom-toast';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

export function showNotification(message: string, type: NotificationType): void {
  switch (type) {
    case 'success':
      customToast.success(message);
      break;
    case 'error':
      customToast.error(message);
      break;
    case 'warning':
      customToast.warning(message);
      break;
    case 'info':
      customToast.info(message);
      break;
    default:
      customToast.show(message);
  }
}
